import React, { useEffect, useState, useRef } from "react";
import {InputField, CheckboxField, useFormContext } from 'clayco-controls';
import  {useTranslation} from 'react-i18next';
import { Col, Row, Button } from 'react-bootstrap';
import { hasTextValue } from "constants/conditions";
import { log } from 'utils/logging';

const WorkerInformation = ({ preloadedAssociate, testMatch, mostRecentYesMatchedAssociate, disableMatchFields, continueRequired, handleMatchValuesChanged }) => {

    const { setValue, getValues } = useFormContext();
    const {t} = useTranslation();
    const [smsConsent, setSmsConsent] = useState(true);
    const [canContinue, setCanContinue] = useState(false);

    const lastNameMatch = useRef(null);
    const phoneNumberMatch = useRef(null);

    useEffect(() => {
        const firstName = getValues('workerInfo.firstName')?.trim();
        if (firstName == null || firstName === '') {

            const defaultFirstName = preloadedAssociate == null ? mostRecentYesMatchedAssociate?.firstName : preloadedAssociate?.firstName
            log.trace('WorkerInformation', 'defaultFirstName', defaultFirstName);

            setValue('workerInfo.firstName', defaultFirstName)
        }
    }, [mostRecentYesMatchedAssociate, preloadedAssociate]) // eslint-disable-line react-hooks/exhaustive-deps

    const lastNameValue = () => (getValues('workerInfo.lastName') ?? '').trim();

    const phoneNumberValue = () => (getValues('workerInfo.phoneNumber') ?? '').trim().replace(/[^0-9\\.]+/g, '');

    const testCanContinue = () => {
        setCanContinue(
            hasTextValue(lastNameValue()) && hasTextValue(phoneNumberValue())
        );
    }

    const testMatchValuesChanged = () => {

        if (lastNameValue() !== lastNameMatch.current || 
            phoneNumberValue() !== phoneNumberMatch.current) {

            handleMatchValuesChanged(lastNameValue(), phoneNumberValue());
        }
    }

    const matchWorker = () => {
        
        lastNameMatch.current = lastNameValue();
        phoneNumberMatch.current = phoneNumberValue();

        testMatch(lastNameValue(), phoneNumberValue());
    }

    const changeSmsConsent = (value) => {
        
        setValue('workerInfo.smsConsent', value);
        setSmsConsent(value);
        log.trace ('workerInfo.smsConsent', getValues('workerInfo.smsConsent'));
    }

    return(
        <>
        <div className='card p-0 my-3'>
            <h6 className="card-header">
                {t('Worker Information')}
            </h6>
            <div className='card-body'>
            <Row>
                <Col>
                    <InputField placeholder={' '} label={t('First Name*')} name={'workerInfo.firstName'} type='text' />
                </Col>
                <Col>
                    <InputField placeholder={' '} label={t('Last Name*')} name={'workerInfo.lastName'} disabled={disableMatchFields} type='text' onChange={testCanContinue} onBlur={testMatchValuesChanged}/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <InputField placeholder={' '} label={t('Phone Number*')} name={'workerInfo.phoneNumber'} disabled={disableMatchFields} type='tel' onChange={testCanContinue} onBlur={testMatchValuesChanged}/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <CheckboxField label={t('Receive Project/Safety notifications via Text')} name={'workerInfo.smsConsent'} onChange={e => changeSmsConsent(!smsConsent)} checked={smsConsent}/>
                </Col>
                <Col className='pt-2'>
                    { continueRequired && <Button className='float-end' disabled={!canContinue} onClick={matchWorker} >{t('Continue')}</Button> }
                </Col>
            </Row>

            </div>
        </div>
        </>
    )
}

export default WorkerInformation;